














import DateRangePicker from './DateRangePicker.vue';
import BackButton from './BackButton.vue';
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({
  name: 'main-content',
  components: {
    BackButton,
    DateRangePicker
  }
})
export default class MainContent extends Vue {
  @State(s => s.AppMod.showDateRangePicker)
  private showPicker!: boolean;
}
